import React from "react";
import Layout from "./Components/Layout";
import styles from "./styles/InnerPage.module.css";

export default function ChineseHoroscope() {
  return (
    <Layout
      title="Chinese Horoscope & Zodiac Signs | MyChineseHoroscope.com"
      description="Explore the Chinese Horoscope system, the twelve zodiac animals, the five elements, and how they influence personality, destiny, and Feng Shui."
    >
      <div className={styles.page}>
        <div className={styles.container}>

          {/* HERO */}
          <header className={styles.hero}>
            <p className={styles.kicker}>Chinese Astrology</p>
            <h1 className={styles.h1}>Understanding the Chinese Horoscope</h1>
            <p className={styles.sub}>
              The Twelve Zodiac Animals, the Five Elements, Yin & Yang, and their influence on personality, destiny, and Feng Shui.
            </p>
          </header>

          {/* INTRO */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>What is the Chinese Horoscope?</h2>
            <p className={styles.p}>
              The Chinese horoscope is an ancient system rooted in Chinese philosophy and lunar calendar traditions.
              It revolves around twelve zodiac animals that repeat in a twelve-year cycle.
              Each sign influences personality, compatibility, timing, and life direction.
            </p>
          </section>

          {/* ZODIAC ANIMALS */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>The Twelve Zodiac Animals</h2>

            <div className={styles.grid2}>
              <ul className={styles.list}>
                <li>Rat — Clever, adaptable, resourceful</li>
                <li>Ox — Reliable, strong, determined</li>
                <li>Tiger — Brave, competitive, bold</li>
                <li>Rabbit — Gentle, elegant, sensitive</li>
                <li>Dragon — Confident, ambitious, powerful</li>
                <li>Snake — Wise, intuitive, analytical</li>
              </ul>

              <ul className={styles.list}>
                <li>Horse — Energetic, independent, adventurous</li>
                <li>Goat — Creative, calm, artistic</li>
                <li>Monkey — Intelligent, innovative, curious</li>
                <li>Rooster — Detail-oriented, punctual, confident</li>
                <li>Dog — Loyal, protective, honest</li>
                <li>Pig — Generous, compassionate, sincere</li>
              </ul>
            </div>
          </section>

          {/* FIVE ELEMENTS */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>The Five Elements</h2>
            <p className={styles.p}>
              Each zodiac sign interacts with one of the five elements —
              Wood, Fire, Earth, Metal, and Water — creating a complete 60-year cycle.
            </p>

            <ul className={styles.list}>
              <li>Wood — Growth, creativity, vitality</li>
              <li>Fire — Passion, leadership, transformation</li>
              <li>Earth — Stability, grounding, reliability</li>
              <li>Metal — Strength, clarity, discipline</li>
              <li>Water — Wisdom, flexibility, intuition</li>
            </ul>
          </section>

          {/* YIN YANG */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Yin & Yang Balance</h2>
            <p className={styles.p}>
              Yin represents receptive and nurturing energy, while Yang represents active and dynamic force.
              Every zodiac sign contains both energies in different proportions, influencing behaviour and life balance.
            </p>
          </section>

          {/* FENG SHUI */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Chinese Horoscope & Feng Shui</h2>
            <p className={styles.p}>
              The Chinese zodiac plays a key role in Feng Shui, helping determine ideal directions,
              colors, room layouts, and energy flow to harmonise personal and environmental Qi.
            </p>

            <p className={styles.p}>
              Combining astrology with Feng Shui allows alignment between inner personality
              and outer environment — supporting health, relationships, and prosperity.
            </p>
          </section>

          {/* BENEFITS */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Why Knowing Your Zodiac Matters</h2>
            <p className={styles.p}>
              Understanding your zodiac sign increases self-awareness and supports better decisions
              in relationships, career, and timing of life events.
            </p>

            <p className={styles.p}>
              A personalised Chinese astrology reading combined with <a href='https://www.pyfsc.com' title='Feng Shui Consultant'>Feng Shui Consultant</a>'s guidance
              offers deeper clarity into your destiny path and energetic balance.
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}